import { LoginFormProps } from '../../types/form';
import Api from '../api/index';
import {
	LOGIN_SUCCESS,
	STORE_USER,
	INITIALIZED,
	LOGOUT,
} from '../constants/types';

export function initialized() {
	return (dispatch: Function): void => dispatch({
		type: INITIALIZED,
		data: true,
	});
}

//= store user
export function storeUser() {
	return (dispatch: Function): void => dispatch({
		type: STORE_USER,
	});
}

//= login success
export function loginSuccess(response: string) {
	return (dispatch: Function): void => dispatch({
		response,
		type: LOGIN_SUCCESS,
	});
}

//= ====================================================
//= FETCH USER DATA
//= ====================================================
function fetchUserData() {
	return (dispatch: Function): void => dispatch({
		type: 'FETCH_USER',
		payload: {
			request: {
				url: 'users/me',
			},
		},
	})
		.then((response: any) => {
			Api.storeUserData(response);
			dispatch(storeUser());
			return Promise.all([
				dispatch(loginSuccess(response)),
			])
				.then(() => {
					dispatch(initialized());
					return response;
				});
		});
}
//= ====================================================
//= LOGIN
//= ====================================================
// (username: string, password: string, appName: string) => (dispatch: Function) => void
export function login(data: LoginFormProps): (dispatch: Function) => void {
	return (dispatch: Function) => dispatch({
		type: 'LOGIN',
		payload: { data },
	})
		.then((response: any) => {
			Api.storeOAuth({
				email: 'uzoamaka@gmail.com',
				loggedInTime: new Date().getTime()
			}, 'coinzero');
			return response;
		})
		.then((response: any) => {
			dispatch(fetchUserData());
			return response;
		})
		.catch((error: Error) => Promise.reject(error));
}
//= ====================================================
//= CHECK AUTH
//= ====================================================
export function checkOauth() {
	return (dispatch: Function) => {
		//= get token from local storage
		const token = localStorage.getItem('@Auth:auth');
		//= if token doesn't exists
		if (!token) {
			return dispatch(initialized());
		}
		//= set token in Api.oauth
		Api.oauth = JSON.parse(token);
		return dispatch({
			type: 'FETCH_USER',
			payload: {
				request: {
					url: '/users/me',
				},
			},
		}).then(() => {
			dispatch(loginSuccess(token));
			dispatch(fetchUserData());
		}).catch(() => {
			dispatch(initialized());
		});
	};
}
//= ====================================================
//= LOGOUT
//= ====================================================
export function logout() {
	return (dispatch: Function): void => {
		localStorage.removeItem('@Auth:appName');
		localStorage.removeItem('@Auth:auth');
		return dispatch({
			type: LOGOUT,
		});
	};
}

//= ====================================================
//= CHANGE PASSWORD
//= ====================================================
export function changePassword(passwordOld: string, newPassword: string) {
    return (dispatch: Function): void => dispatch({
		type: 'CHANGE_PASSWORD',
		payload: {
			request: {
				method: 'PATCH',
				data: {
					passwordOld,
					password: newPassword,
					passwordRepeat: newPassword,
				},
				url: `/users/${Api?.user?.payload?.data.id}/change-password`,
			},
		},
	}).catch((error: Error) => Promise.reject(error));
}
